import React from "react";
import closeIcon from '../../assets/img/close_black.svg';

const ModalWrapper = ({
  children, handleToggleModal
}) => {

  return (
    <>
      <div className="storefront-modal-wrapper" onClick={handleToggleModal}>
        <div className="storefront-modal-wrapper-container" onClick={(e) => e.stopPropagation()}>
          <div className="storefront-modal-wrapper-close">
            <img src={closeIcon} onClick={handleToggleModal} alt=""/>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default ModalWrapper;
